(function () {
  var root = document.documentElement;
  if (!root.classList.contains('gc-site')) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var boot = document.querySelector('[data-gc-boot]');
  if (boot && !reduced && !(window.Shopify && window.Shopify.designMode)) {
    var log = boot.querySelector('[data-gc-boot-log]');
    var fill = boot.querySelector('[data-gc-boot-fill]');
    var lines = [
      { text: '> loading gulag_creations...', cls: '' },
      { text: '> storefront_assets: OK', cls: '' },
      { text: '> community_hub: connected', cls: 'gc-boot__line--gold' },
      { text: '> welcome, survivor.', cls: 'gc-boot__line--gold' }
    ];
    var step = 0;

    function addLine() {
      if (!log || step >= lines.length) {
        if (fill) fill.style.width = '100%';
        setTimeout(function () {
          boot.classList.add('is-done');
          root.classList.remove('is-loading');
          root.classList.add('is-loaded');
        }, 280);
        return;
      }
      var item = lines[step];
      var el = document.createElement('span');
      el.className = 'gc-boot__line' + (item.cls ? ' ' + item.cls : '');
      el.textContent = item.text;
      log.appendChild(el);
      if (fill) fill.style.width = Math.round(((step + 1) / lines.length) * 100) + '%';
      step += 1;
      setTimeout(addLine, step === 1 ? 160 : 220);
    }

    setTimeout(addLine, 100);
  } else if (boot) {
    boot.classList.add('is-done');
    root.classList.remove('is-loading');
    root.classList.add('is-loaded');
  }
})();
